import React from 'react';
import {InventoryActivityReportViewVO} from "../../../types/model/valueObject/InventoryActivityReportViewVO";
import {AdminInterchangesCardListItem} from "./AdminInterchangesCardListItem";
import {withLoader} from "../../hocs/withLoader";
import {LocationCardSkeleton} from "../../common/reports/loadingSkeletons/LocationCardSkeleton";

type AdminInterchangesCardListProps = {
  items?: InventoryActivityReportViewVO[];
  expandByIndex: Array<boolean>;
  onToggleExpand: (index: number) => void;
}

const AdminInterchangesCardList = ({
  items,
  expandByIndex,
  onToggleExpand
}: AdminInterchangesCardListProps) => {

  if (!items?.length) {
    return null;
  }

  return <>
    {
      items.map((item, index) =>
        <AdminInterchangesCardListItem
          key={index}
          item={item}
          expanded={expandByIndex[index]}
          onToggleExpand={() => onToggleExpand(index)}
        />
      )
    }
  </>
}

const skeletonLoader = () => Array.from({ length: 10 }).map((_, index) => (
  <LocationCardSkeleton key={index} />
));

const AdminInterchangesCardListWithLoader = withLoader(AdminInterchangesCardList, skeletonLoader);

export {
  AdminInterchangesCardList,
  AdminInterchangesCardListWithLoader
};
